import { Button } from '@material-ui/core'
import { getCurrentUser, signIn } from 'aws-amplify/auth'
import * as React from 'react'
import { useEffect } from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'

import { SectionSubTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { useAppContext } from '../../services/app-context'
import { useCognito } from '../../services/cognito-services'
import { finalizeSignUp } from '../../services/user-services'
import { containerStyles } from '../../styles/ContainerStyles'
import { invoke } from '../../utils/helper'

export const FinalizeSignUp: React.FC = () => {
    const [firstName, setFirstName] = React.useState<string>('')
    const [lastName, setLastName] = React.useState<string>('')
    const { signedIn } = useCognito()

    const styles = containerStyles()
    const history = useHistory()
    const { setUser } = useAppContext()

    const { state }: { state: {
            email: string, password: string, firstName: string, lastName: string
        } } = useLocation()

    const fromSignUp = !!(state?.email && state.password)

    useEffect(() => {
        const forceLoginAndFinalize = async () => {
            await invoke(async () => {
                // User may already be signed in from ConfirmSignUp
                try {
                    await signIn({
                        username: state.email,
                        password: state.password
                    })
                } catch (e: any) {
                    if (e.name !== 'UserAlreadyAuthenticatedException') {
                        throw e
                    }
                }

                setUser(
                    await finalizeSignUp({
                        firstName: state.firstName,
                        lastName: state.lastName,
                        email: state.email
                    })
                )
            }, {
                operation: 'Afslutter'
            })

            history.push('/')
        }

        if (fromSignUp) {
            forceLoginAndFinalize().then()
        }
    }, [])

    if (fromSignUp) {
        return null
    } else if (signedIn === false) {
        return <Redirect to="/log-ind"/>
    } else if (signedIn === undefined) {
        return null // Still checking auth status
    }

    const inputsAreValid = firstName.length >= 2 && lastName.length >= 3

    const finalize = async () => {
        await invoke(async () => {
            const currentUser = await getCurrentUser()

            const user = await finalizeSignUp({
                firstName, lastName, email: currentUser.username
            })
            setUser(user)
        }, {
            operation: 'Afslutter'
        })

        history.push('/')
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.innerAuthContainer}>
                <SectionSubTitle text="Dine Detaljer"/>
                <p style={{ color: 'white', textAlign: 'center' }}>Vi mangler bare dit fornavn og efternavn :)</p>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <TextInputEx
                        fullWidth
                        value={firstName}
                        onChange={setFirstName}
                        label="Fornavn"/>
                    <TextInputEx
                        fullWidth
                        value={lastName}
                        onChange={setLastName}
                        label="Efternavn"/>
                </div>
                <div>
                    <Button
                        onClick={finalize}
                        className="btn-auth"
                        disabled={!inputsAreValid}>
                        Afslut Detaljer
                    </Button>
                </div>
            </div>
        </div>
    )
}
